import { API } from "aws-amplify";

export default async function listScheduledTransactions(key) {
  const params = key ? `exclusiveStartKey=${key}` : "";
  return await API.get("payments", `list-all-schedule-payments/?${params}`);
}
